import { render, staticRenderFns } from "./AnimeDetail.vue?vue&type=template&id=4ca293f7&scoped=true&"
import script from "./AnimeDetail.vue?vue&type=script&lang=js&"
export * from "./AnimeDetail.vue?vue&type=script&lang=js&"
import style0 from "./AnimeDetail.vue?vue&type=style&index=0&id=4ca293f7&prod&scoped=true&lang=scss&"
import style1 from "./AnimeDetail.vue?vue&type=style&index=1&id=4ca293f7&prod&scoped=true&lang=css&"
import style2 from "./AnimeDetail.vue?vue&type=style&index=2&id=4ca293f7&prod&lang=css&"
import style3 from "./AnimeDetail.vue?vue&type=style&index=3&id=4ca293f7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca293f7",
  null
  
)

export default component.exports